import {
    FETCH_TICKET_5D,
    LIST_TICKET_5D
} from "./types";

const init = {
    isLoading: false,
    isLoadingBet: false,
    data: {
        tickets: [],
        drawShifts: [],
        summary: {
            grandTotalUsd: {
                betAmount: 0,
                waterAmount: 0,
                winAmount: 0,
                winLoseAmount: 0
            },
            grandTotalKhr: {
                betAmount: 0,
                waterAmount: 0,
                winAmount: 0,
                winLoseAmount: 0
            }
        },
    },
    filter: {},
    page: 1,
    totals: 0,
    size: 25
};
export default (state = init, {type, payload}) => {
    switch (type) {
        case FETCH_TICKET_5D:
            return {
                ...state,
                filter: payload,
                isLoading: true
            };
        case LIST_TICKET_5D:
            return {
                ...state,
                ...payload,
                isLoading: false,
            };
        default:
            return state;
    }
}